import { render, staticRenderFns } from "./ReferralBody.vue?vue&type=template&id=4e763c02"
import script from "./ReferralBody.vue?vue&type=script&lang=js"
export * from "./ReferralBody.vue?vue&type=script&lang=js"
import style0 from "./ReferralBody.vue?vue&type=style&index=0&id=4e763c02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports